import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class tagsMultiSelectListCtrl implements IController {

  type?: string;
  selectedNames: any;
  ngPlaceholder: any;
  isAllowExcludeMode: boolean;
  isExcludeMode: boolean;
  onChange: Function;
  onToggleExcludeMode: Function;

  private tagsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $tags, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.tagsRef = this.$tags();
    this.loadLimit = 20;

    this.tagsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.tagsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedNames) {
      this.selectedKeys = [];
      _.forEach(this.selectedNames, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(tagName, isSelected) {
    this.onChange({
      tagNames: isSelected ? _.concat(this.selectedNames, [tagName]) :
        _.filter(this.selectedNames, (id) => {
          return id !== tagName;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({tagNames: []});
    } else {
      this.onChange({tagNames: this.infiniteScroll?.getItems()?.map((tag) => tag.name)});
    }
  }

  onToggleExclude() {
    if (this.selectedKeys['noTag']) {
      const tagIndex = this.selectedNames.findIndex(t => t === 'noTag');
      const selectedNamesCopy = angular.copy(this.selectedNames);
      selectedNamesCopy.splice(tagIndex, 1)
      this.onChange({tagNames: selectedNamesCopy});
    }

    this.onToggleExcludeMode({isExcludeMode: !this.isExcludeMode});
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(tag => tag.name), this.selectedNames);
    return this.isSelectAll;
  }


  private _reload() {
    this.tagsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      type: this.type,
      sort: 'name,asc'
    };
  }

}

angular
  .module('bringoz.admin.tags')
  .component('tagsMultiSelectList', {
    bindings: {
      type: '<?',
      selectedNames: '<',
      ngPlaceholder: '@?',
      isAllowExcludeMode: '<?',
      isExcludeMode: '<?',
      onToggleExcludeMode: '&',
      onChange: '&'
    },
    template: require('./tags-multi-select-list.html').default,
    controller: tagsMultiSelectListCtrl
  });
